import { createReducer } from '@reduxjs/toolkit';
import { DeepWritable } from 'ts-essentials';

import { AppPathConfig } from 'utils/url/appPaths';

import { conversationsActions } from './conversations.actions';

type ConversationsState = {
  /** The last search params used to read conversations. */
  lastSearchParams: AppPathConfig['/conversations']['search'];
};

const initialState: ConversationsState = {
  lastSearchParams: {
    status: ['open'],
  },
};

export const conversationsReducer = createReducer(initialState, (builder) =>
  builder.addCase(conversationsActions.setLastSearchParams, (state, action) => {
    const {
      agentIds,
      channels,
      directions,
      limit,
      offset,
      queueIds,
      requesterIds,
      status,
      sort,
    } = action.payload.apiArg;

    const searchParams: AppPathConfig['/conversations']['search'] = {
      ...(typeof agentIds === 'boolean'
        ? {
            assigned: agentIds.toString(),
          }
        : {
            agent: agentIds,
          }),
      channel: channels,
      direction: directions,
      limit: limit?.toString(),
      offset: offset?.toString(),
      ...(typeof queueIds === 'boolean'
        ? {
            queued: queueIds.toString(),
          }
        : {
            queue: queueIds,
          }),
      requester: requesterIds,
      status:
        typeof status === 'string'
          ? status
          : status?.filter((status) => status !== 'awaitingpending'),
      ...(sort ? { sort: Object.values(sort).join(':') } : {}),
    };

    state.lastSearchParams = searchParams as DeepWritable<
      AppPathConfig['/conversations']['search']
    >;
  }),
);
